import controller from './kform-builder-conditional.controller';
import template from './kform-builder-conditional.html';

const kformBuilderConditionalDirective = /* @ngInject */ () => ({
	restrict: 'E',
	scope: true,
	template,
	controller,
});

export default kformBuilderConditionalDirective;
